export default "/fonts/iconfont.ttf?493e8bd045c80b21f3ba7554c3759779";